import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import { toIntegerOrNull, isA } from '../utils';

// This is the min and max integer supported by our requirements and ElasticSearch's 'integer' type, not
// Javascript's max integer.
var MIN_INTEGER = 0;
var MAX_INTEGER = 2147483647;
var nullIfTooBig = victim => victim > MAX_INTEGER ? null : victim;
var nullIfTooSmall = victim => victim < MIN_INTEGER ? null : victim;
var clampValue = value => isNumber(value) ? nullIfTooBig(nullIfTooSmall(value)) : value;
var getFinalValue = (value, acceptString) => acceptString && isString(value) ? value : clampValue(toIntegerOrNull(value));
class Range {
  constructor(rangeOrArrayParam, acceptString) {
    var rangeOrArray = rangeOrArrayParam || {};
    var range = (Array.isArray(rangeOrArray) ? [rangeOrArray[0], rangeOrArray[1]] : [rangeOrArray.min, rangeOrArray.max]).map(value => getFinalValue(value, acceptString));
    this.min = range[0];
    this.max = range[1];
  }
  isRange() {
    return true;
  }
  getSingleValue() {
    return this.min === this.max ? this.min : null;
  }
}
Range.isInstance = value => isA(value, 'Range');
Range.MAX_INTEGER = MAX_INTEGER;
Range.MIN_INTEGER = MIN_INTEGER;
export default Range;